export default "__VITE_ASSET__CzRiZJ3r__"